import { ChangeDetectionStrategy, Component, type OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import * as FlatModels from '@medsurf/flat-models';
import * as FlatDesigns from '@medsurf/flat-designs';
import { ZodSharedValidator } from "@medsurf/flat-validators";

@Component({
    selector: 'medsurf-page-title-dialog',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './page-title-dialog.component.html',
    styleUrls: ['./page-title-dialog.component.scss'],
    standalone: false
})
export class PageTitleDialogComponent implements OnInit {
  @ViewChild('titleInputText', {static: false}) titleInputText: FlatDesigns.TextInputFormControlDesign;
  
  pageForm = new FormGroup(
    {
      title: new FormControl(''),
    },
    {
      validators: ZodSharedValidator.validate(
        FlatModels.PageEntityModels.PageSchema
        .pick({
          title: true,
        })
      ),
      updateOn: 'change'
    }
  );
  readonly FlatModels = FlatModels;

  constructor(public dynamicDialogRef: DynamicDialogRef,
              public dynamicDialogConfig: DynamicDialogConfig) {
    // Title
    if (this.dynamicDialogConfig?.data?.title) {
      this.pageForm.patchValue({title: this.dynamicDialogConfig.data.title});
    }
  }
  
  ngOnInit() {
    // Autofocus
    setTimeout(() => {
      this.titleInputText?.inputElement?.nativeElement?.focus();
    });
  }
  
  onSubmit() {
    if (this.pageForm.invalid || this.pageForm.value.title === this.dynamicDialogConfig.data.title) {
      return;
    }
    
    // Close Dialog
    this.dynamicDialogRef.close({result: true, title: this.pageForm.value.title })
  }
}
